import type { ReactElement } from 'react';
import { useT } from '../lib/i18n';

/**
 * The loading indicator, used wherever the wait is short.
 *
 * `role="status"` with a written label rather than a bare spinning circle: a
 * screen reader announces the wait instead of leaving the page silent, and the
 * label is a real sentence because that is what gets announced.
 */
export function Spinner({ label }: { label?: string }): ReactElement {
  const t = useT();
  return (
    <div className="flex items-center gap-3 text-ink-500" role="status" aria-live="polite">
      <span
        className="size-5 animate-spin rounded-full border-2 border-line-strong border-t-accent"
        aria-hidden="true"
      />
      <span className="text-sm">{label ?? t('common.loadingLabel')}</span>
    </div>
  );
}
